import { reactive } from 'vue'

const footer = reactive({
  visible: true,
  back: {
    text: 'Voltar',
    action: null,
  },
  next: {
    text: 'Continuar',
    action: null,
    disabled: false,
    hidden: false,
    loading: false,
  },
})

export function useOnboardingFooter() {
  // Merge parcial: uma chamada tipo `setFooter({ next: { disabled: true } })`
  // (comum em watchers, ex: habilitar/desabilitar o botão conforme validação)
  // só deve tocar `disabled` — sobrescrever `text`/`action` com os defaults
  // apagaria o texto e o handler configurados antes (bug real, corrigido aqui:
  // AttachmentsPage.vue perdia "Finalizar solicitação"/`save` toda vez que
  // `canContinue` mudava).
  function setFooter({ visible, back, next } = {}) {
    if (visible !== undefined) footer.visible = visible
    if (back) {
      if (back.text !== undefined) footer.back.text = back.text
      if (back.action !== undefined) footer.back.action = back.action
    }
    if (next) {
      if (next.text !== undefined) footer.next.text = next.text
      if (next.action !== undefined) footer.next.action = next.action
      if (next.disabled !== undefined) footer.next.disabled = next.disabled
      if (next.hidden !== undefined) footer.next.hidden = next.hidden
      if (next.loading !== undefined) footer.next.loading = next.loading
    }
  }

  function resetFooter() {
    footer.visible = true
    footer.back.text = 'Voltar'
    footer.back.action = null
    footer.next.text = 'Continuar'
    footer.next.action = null
    footer.next.disabled = false
    footer.next.hidden = false
    footer.next.loading = false
  }

  return { footer, setFooter, resetFooter }
}
